import { Component, OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { Chart } from 'chart.js';
import { ActivatedRoute, Router } from '@angular/router';
import { NavService } from '../providers/nav.service';
import { ApiService } from '../providers/api.service';
// import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonService } from '../providers/common.service';
import { Constants, MLBBatterToolTip, NBAToolTip, NFLToolTip, platformList, SharedService, sportList } from '../shared.service';
import { isEmptyObject } from 'jquery';
import { Subject } from "rxjs";
import { element } from 'protractor';
import { on } from 'process';
@Component({
  selector: 'app-trends',
  templateUrl: './trends.component.html',
  styleUrls: ['./trends.component.css']
})
export class TrendsComponent implements OnInit, OnDestroy {

  loginUserDetails: any = JSON.parse(localStorage.getItem('userDetails'));
  profileDet: any = {};
  FiltersData: any = {};
  initialGameStyleId = '';

  PopupLast5Position = '';
  popupLast5SomeRange = [0, 100000.00];
  popupLast5SalaryRange = '0, 100000.00';
  popUpLast5playerList = [];
  popupLast5TxtQueryChanged: Subject<string> = new Subject<string>();

  popupTrendPlayerList: any = {};
  popupTrendfinalGraphData = {
    labels: [],
    datasets: []
  };
  popupTrendMyChart;
  playerStatus = '';
  showPlayerStatus = false;
  defualtPopupTab = 'Last';
  playerGameLogList = [];
  selectedPlayerForPopup: any = {};
  selectedFilters: any = {
    sportId: '1',
    platformId: '1',
    recordType: 'game',
    // expensiveSelectedPlayer: '',
    categoryName: '',
    player_type: 'pitching',
    limit: this.sharedService.defaultLimit,
    players: {
      players: []
    },
    Path: 'Trends'
  };
  showChildComponent = false;
  trendsPlayerData: any = {};
  selectedSlteId = '';

  finalGraphData = {
    labels: [],
    datasets: []
  };

  players = {
    players: [{ player_id: '', opp: '', ha: '' }]
  };

  // SideBar Filters
  slate: any = [];
  gameStyleSlate: any = {};
  playerTeamList: any = [];
  tableType = sportList[sportList.NFL];
  sportList = sportList;

  addPlayerList: any = {
    players: [{ player_id: '', opp: '', ha: '', teamList: [] }]

  };

  halist = [
    { name: 'Home', type: 'h' },
    { name: 'Away', type: 'a' },
    { name: 'Both', type: '' },
  ];

  myChart;

  radioStatus = true;
  teamListPerPlayer: any = [];
  boardPlayerList: any = {};
  isSideFilterShow = true;
  categoryName = '';
  playerId: any;
  selectedGameId: any;
  selectedSlate: any;
  NFLToolTip = new NFLToolTip();
  NBAToolTip = new NBAToolTip();
  Constants = new Constants();
  MLBBatterToolTip = new MLBBatterToolTip();
  userDetail = JSON.parse(localStorage.getItem('userDetails'));
  constructor(
    private route: Router,
    private api: ApiService,
    private changeDetectorRef: ChangeDetectorRef,
    private SpinnerService: NgxSpinnerService,
    private commonService: CommonService,
    private navService: NavService,
    public sharedService: SharedService,
    private activeRoute: ActivatedRoute
  ) {
     this.activeRoute.params.subscribe(params => {
       this.playerId = params.id;
       this.selectedFilters.gameStyle = params.gameid;
       this.selectedFilters.slate = params.slate;
     });

    if (this.loginUserDetails && this.loginUserDetails.userDetails) {
      this.profileDet = this.loginUserDetails.userDetails;
    }
    if (this.userDetail && this.userDetail.currentSport_id) {
      this.commonService.platformandsport.sport_id = this.userDetail.currentSport_id;
    }
    if (this.userDetail && this.userDetail.currentPlatform_id) {
      this.commonService.platformandsport.platform_id = this.userDetail.currentPlatform_id;
    }
    this.selectedFilters.sportId = this.commonService.platformandsport.sport_id.toString();
    this.selectedFilters.platformId = this.commonService.platformandsport.platform_id.toString();
  }

  ngOnInit() {
    this.defualtFilters();
    // this.sharedService.clearFilters.subscribe(() => {
    //   this.selectedFilters = {
    //     sportId: '1',
    //     platformId: '1',
    //     recordType: 'game',
    //     // expensiveSelectedPlayer: '',
    //     categoryName: '',
    //     player_type: 'batting',
    //     limit: this.sharedService.defaultLimit,
    //     players: {
    //       players: []
    //     },
    //     Path: 'Trends'
    //   };
    //   this.defualtFilters(true)
    // });
    this.selectedFilters.Path = "Trends";

  }

  defualtFilters(isDefault?: boolean) {

    const filtersObj = {
      platform_id: this.selectedFilters.platformId,
      sport_id: this.selectedFilters.sportId,
      user_id: (this.loginUserDetails && this.loginUserDetails.user_id) ? this.loginUserDetails.user_id : '',
      type: 'trends',
    };
    this.SpinnerService.show();
    this.api.boardInitialLoadData(filtersObj).subscribe(data => {
      this.SpinnerService.hide();
      if (data && data.code && data.code === 100 && filtersObj.type === "trends") {
        let filters = !isDefault && this.sharedService.getFilter('trends');
        this.FiltersData = data.data;
        this.selectedFilters.slate = filters ? Number(filters.slate) : this.selectedFilters.slate;
        this.selectedFilters.gameStyle = filters ? Number(filters.gameStyle) : this.selectedFilters.gameStyle;

        if(this.userDetail.fieldType !== undefined){
          this.selectedFilters.player_type =  this.userDetail.fieldType;
        }else{
          this.selectedFilters.player_type = this.selectedFilters.player_type ? this.selectedFilters.player_type : 'pitching';
        }

        if (this.FiltersData && this.FiltersData.gameStyleList && this.FiltersData.gameStyleList.length > 0) {
          if (this.FiltersData.gameStyleList.some(e => e.game_style_id == this.selectedFilters.gameStyle)) {
            this.selectedFilters.gameStyle = this.selectedFilters.gameStyle;
          } else {
            const classicObj = this.FiltersData.gameStyleList.find(x => (x.game_style_name.toLowerCase() == 'classic' || x.game_style_name.toLowerCase() == 'full roster'));
            this.selectedFilters.gameStyle = classicObj ? classicObj.game_style_id : this.FiltersData.gameStyleList[0].game_style_id;
            // this.selectedFilters.gameStyle = this.FiltersData.gameStyleList[0].game_style_id;
          }
          this.selectedFilters.categoryName = this.FiltersData.categoryList[0].value;
          this.categoryName = this.FiltersData.categoryList[0].name;
          // this.FiltersData.gameStyleList.forEach(element => {
          //   if (this.selectedFilters.gameStyle == element.game_style_id && element.slates && element.slates.length > 0) {
          //     if (element.slates.some(e => e.slates_id == this.selectedFilters.slate)) {
          //       this.selectedFilters.slate = this.selectedFilters.slate;
          //     } else {
          //       this.selectedFilters.slate = element.slates[0].slates_id;
          //     }
          //     this.slate = this.getSlates(element.slates);
          //   }
          // });

          let obj = this.FiltersData.gameStyleList.filter(element => this.selectedFilters.gameStyle == element.game_style_id && element.slates && element.slates.length > 0)
          // if (obj.length > 0) {
          //   if (obj[0].slates.some(e => e.slates_id == this.selectedFilters.slate)) {
          //     this.selectedFilters.slate = this.selectedFilters.slate;
          //   } else {
          //     this.selectedFilters.slate = obj[0].slates[0].slates_id;
          //   }

          //   this.slate = this.getSlates(obj[0].slates);

          // }


          if (obj.length > 0) {
            if (this.commonService.platformandsport.platform_id == platformList.DraftKings) {
              const blankSlates = obj[0].slates.filter(({ slates_label }) => slates_label === "" || slates_label === null);
              const withoutBlankSlates = obj[0].slates.filter(({ slates_label }) => slates_label !== "" && slates_label !== null);
              this.slate = [...blankSlates, ...withoutBlankSlates];
              this.selectedFilters.slate = this.slate[0].slates_id;
            }
            if (this.commonService.platformandsport.platform_id == platformList.FanDuel) {
              const blankSlates = obj[0].slates.filter(({ slates_label }) => slates_label === "Main" || slates_label === null);
              const withoutBlankSlates = obj[0].slates.filter(({ slates_label }) => slates_label !== "Main" && slates_label !== null);
              this.slate = [...blankSlates, ...withoutBlankSlates];
              this.selectedFilters.slate = this.slate[0].slates_id;
            }
          }
          //this.sharedService.updatefiltersSelection(this.selectedFilters, 'trends')
        }
        /*OVERWRITE LOCAL STORAGE SLATES*/
        if (localStorage.getItem('uselocalStorage') && localStorage.getItem('uselocalStorage') == 'yes') {
          this.selectedFilters.slate = JSON.parse(localStorage.getItem('userDetails')).slateSelection ? JSON.parse(localStorage.getItem('userDetails')).slateSelection.slate : this.FiltersData.gameStyleList.filter(element => this.initialGameStyleId == element.game_style_id && element.slates && element.slates.length > 0)[0].slates[0].slates_id;
        }
        localStorage.setItem('uselocalStorage', 'yes');
        this.sharedService.updatefiltersSelection(this.selectedFilters, 'trends')

        this.PlayersTeamListOfSideBaFilters(false);
        // console.log('initial data load successfully');
      } else {
      }
    }, (err) => {
      this.SpinnerService.hide();
      // console.log('Somthing went wrong');
    });
  }

  getSlates(slate) {
    const blankSlates = slate.filter(({ slates_label }) => slates_label === " () ");
    const withoutBlankSlates = slate.filter(({ slates_label }) => slates_label !== " () ");
    return [...blankSlates, ...withoutBlankSlates]
  }

  showChild() {
    if (this.showChildComponent) {
      this.showChildComponent = false;
    }
    this.changeDetectorRef.detectChanges();

    this.showChildComponent = true;
  }

  userToSignup() {
    if (!this.loginUserDetails.isLogin) {
      this.sharedService.userToSignup();
    }
  }

  trendPlayerList() {
    if (this.selectedFilters.Path === 'Trends') {
      // const players = {
      //   players: [
      //     { player_id: '', opp: '', ha: '' }]
      // };
      /* PlayerList data*/
      if (this.selectedFilters.sportId == sportList.NFL) {
        this.tableType = sportList[sportList.NFL];
      } else if (this.selectedFilters.sportId == sportList.NBA) {
        this.tableType = sportList[sportList.NBA];
      } else if (this.selectedFilters.sportId == sportList.MLB) {
        this.tableType = sportList[sportList.MLB];
      }
      const boardPlayersFiltersData = {
        user_id: (this.loginUserDetails && this.loginUserDetails.user_id) ? this.loginUserDetails.user_id : '',
        sport_id: this.selectedFilters.sportId,
        slates_id: this.selectedFilters['slate'].toString(),
        salary_range: '0, 100000.00',
        platform_id: this.selectedFilters.platformId,
        player_type: this.selectedFilters.player_type ? this.selectedFilters.player_type : '',
        trends_players: (this.selectedFilters.players.players.length > 0) ? JSON.stringify(this.selectedFilters.players) : JSON.stringify(this.players),
        trends_limit: this.selectedFilters.limit
      };
      this.boardPlayerList = [];

      this.SpinnerService.show();
      this.api.playerList(boardPlayersFiltersData).subscribe(item => {
        if (item && item.code == 100) {
          if (item.data.listPlayer && item.data.listPlayer.length > 0) {
            if (this.tableType == sportList[sportList.MLB]) {
              this.setMLBColor(item);
            }
            // this.dropdownChanged = false;
            this.boardPlayerList = item.data.listPlayer;
          }

        }
      }, (err) => {
        this.SpinnerService.hide();
      });


      const trendsPlayersFiltersData = {
        sport_id: this.selectedFilters.sportId,
        platform_id: this.selectedFilters.platformId,
        category_name: this.selectedFilters.categoryName,
        record_type: this.selectedFilters.recordType,
        limit: this.selectedFilters.limit,
        players: (this.selectedFilters.players.players.length > 0) ? JSON.stringify(this.selectedFilters.players) : JSON.stringify(this.players),
        player_type: this.selectedFilters.player_type,
      };
      this.SpinnerService.show();
      this.api.trendsPlayerList(trendsPlayersFiltersData).subscribe(item => {
        this.SpinnerService.hide();
        if (item && item.code == 100) {
          this.trendsPlayerData = item.data;
        } else {
          this.trendsPlayerData = { data: [], labelList: [] };
        }

        this.graphView();
      }, (err) => {
        this.SpinnerService.hide();
        this.trendsPlayerData = { data: [], labelList: [] };
        this.graphView();
        // console.log('something went wrong');
      });
    }

  }

  graphView() {
    this.finalGraphData = {
      labels: [],
      datasets: []
    };
    if (this.trendsPlayerData && this.trendsPlayerData.labelList.length > 0) {
      let count = 1;
      this.trendsPlayerData.data.forEach(element => {
        let tempvalue = {};
        if (element != null) {
          let lineColor = 'rgba(255,126,0)';
          if (count == 2) {
            lineColor = 'rgba(0,100,246)';
          } else if (count == 3) {
            lineColor = 'rgba(209,0,222)';
          } else if (count == 4) {
            lineColor = 'rgba(51,204,102)';
          } else if (count == 5) {
            lineColor = 'rgba(255,0,51)';
          }

          tempvalue = {
            label: element.player_name,
            opp_titles: element.opp_titles,
            category: element.category,
            dates: element.dates,
            fill: false,
            lineTension: '0',
            borderWidth: '2',
            backgroundColor: lineColor,
            borderColor: lineColor,
            pointBackgroundColor: lineColor,
            pointBorderColor: 'rgba(0,0,0)',
            pointBorderWidth: '1',
            data: element.points
          };
          count++;
        } else {
          tempvalue = null;
          this.finalGraphData.labels.push(null);
        }

        this.finalGraphData.labels = this.trendsPlayerData.labelList;
        // this.finalGraphData.labels = element.dates;
        this.finalGraphData.datasets.push(tempvalue);
      });
    } else {
      this.finalGraphData = null;
    }

    if (this.myChart) {
      this.myChart.chart.clear();
      this.myChart.chart.destroy();
      this.myChart.destroy();
      // this.myChart.remove();
    }

    if (this.finalGraphData && this.finalGraphData.datasets) {
      this.finalGraphData.datasets = this.finalGraphData.datasets.filter((el) => {
        return el != null;
      });
    }

    if (this.finalGraphData && this.finalGraphData.labels) {
      this.finalGraphData.labels = this.finalGraphData.labels.filter((el) => {
        return el != null;
      });
    }

    const ctx = document.getElementById('myChart');

    this.myChart = new Chart(ctx, {
      type: 'line',
      data: this.finalGraphData,
      options: {
        responsive: true,
        title: {
          display: false
        },
        tooltips: {
          hideDelay: 0,
          callbacks: {
            title(tooltipItem, data) {
              return data.datasets[tooltipItem[0].datasetIndex].label;
            },
            label(tooltipItem, data) {
              const label = [];
              label.push('Date : ' + data.datasets[tooltipItem.datasetIndex].dates[tooltipItem.index]);
              label.push('Opponent : ' + data.datasets[tooltipItem.datasetIndex].opp_titles[tooltipItem.index]);
              label.push(data.datasets[tooltipItem.datasetIndex].category + ' : ' + Math.round(tooltipItem.yLabel * 100) / 100);

              return label;
            }
          }
        },
        hover: {
          mode: 'nearest',
          intersect: true
          // mode: null,
          // intersect: false
        },
        scales: {
          xAxes: [{
            display: true,
            scaleLabel: {
              display: false,
              labelString: 'Games'
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
            display: true,
            scaleLabel: {
              display: false,
              labelString: 'Usage %'
            }
          }]
        }
      }
    });

    this.myChart.render();

  }

  chartHovered({ event, active }: { event: MouseEvent, active: {}[] }) {
    // console.log(event, active);
  }

  chartClicked({ event, active }: { event: MouseEvent, active: {}[] }) {
    // console.log(event, active);
  }

  getPlatformandSport(data) {

    // console.log(data);
    this.selectedFilters.platformId = data.platformId;
    this.selectedFilters.sportId = data.sportId;
    this.selectedFilters.limit = this.sharedService.defaultLimit;
    this.selectedFilters.recordType = 'game';
    this.playerTeamList = [];
    this.slate = [];
    this.selectedFilters.Path = "Trends";
    if(data.sportId != 3)
      this.selectedFilters.player_type = "pitching";

    this.addPlayerList.players = [{ player_id: '', opp: '', ha: '' }];
    this.defualtFilters();
  }

  ngOnDestroy() {
    const currentUrl = this.route.url;
    this.navService.changeNavHeaderActive(currentUrl);
  }


  // GameStyle
  changeGameStyle(item) {

    this.selectedFilters.slate = '';
    this.slate = [];
    this.playerTeamList = [];
    this.addPlayerList.players = [{ player_id: '', opp: '', ha: '' }];
    if (item != '') {
      if (this.FiltersData && this.FiltersData.gameStyleList) {
        // this.FiltersData.gameStyleList.forEach(element => {
        //   if (item == element.game_style_id && element.slates && element.slates.length > 0) {
        //     this.slate = element.slates;
        //     this.selectedFilters.slate = this.slate[0].slates_id;
        //     this.sharedService.updatefiltersSelection(this.selectedFilters, 'trends')
        //     this.PlayersTeamListOfSideBaFilters(true);
        //   }
        // });
        let obj = this.FiltersData.gameStyleList.filter(element => item == element.game_style_id && element.slates && element.slates.length > 0);
        // if (obj.length > 0) {
        //   this.slate = obj[0].slates;
        //   this.selectedFilters.slate = this.slate[0].slates_id;
        //   this.sharedService.updatefiltersSelection(this.selectedFilters, 'trends')
        //   this.PlayersTeamListOfSideBaFilters(true);
        // }


        if (obj.length > 0) {

          if (this.commonService.platformandsport.platform_id == platformList.DraftKings) {
            const blankSlates = obj[0].slates.filter(({ slates_label }) => slates_label === "" || slates_label === null);
            const withoutBlankSlates = obj[0].slates.filter(({ slates_label }) => slates_label !== "" && slates_label !== null);
            this.slate = [...blankSlates, ...withoutBlankSlates];
            this.selectedFilters.slate = this.slate[0].slates_id;

          }
          if (this.commonService.platformandsport.platform_id == platformList.FanDuel) {
            const blankSlates = obj[0].slates.filter(({ slates_label }) => slates_label === "Main" || slates_label === null);
            const withoutBlankSlates = obj[0].slates.filter(({ slates_label }) => slates_label !== "Main" && slates_label !== null);
            this.slate = [...blankSlates, ...withoutBlankSlates];
            this.selectedFilters.slate = this.slate[0].slates_id;
          }
        }
        this.PlayersTeamListOfSideBaFilters(true);
        this.sharedService.updatefiltersSelection(this.selectedFilters, 'trends');
      }
    } else {
      if (this.myChart) {
        this.trendsPlayerData = { data: [], labelList: [] };
        this.graphView();
      }
    }
  }

  changeSlate(slateId) {

    this.playerTeamList = [];
    this.addPlayerList.players = [{ player_id: '', opp: '', ha: '' }];
    this.PlayersTeamListOfSideBaFilters(true);
    this.sharedService.updatefiltersSelection(this.selectedFilters, 'trends')
  }

  onPlayerChangeEvent(playerId, index) {
    let tempTeamdata;
    this.playerTeamList.forEach(element => {
      if (element.player_id == playerId) {
        tempTeamdata = element.opp.split(',');
      }
    });

    tempTeamdata = this.setTeamList(tempTeamdata);
    const defaultPlayerData = { player_id: playerId, opp: '', ha: '', teamList: tempTeamdata };

    this.addPlayerList.players[index] = defaultPlayerData;
  }


  // Side Bar Filters functionality
  changeTypeHaTrends(event) {
    // this.selectedFilters.ha = event.target.value;
  }

  onAddPlayerList() {
    if (this.addPlayerList.players.length != 5) {
      // const emptyPlayerData = { player_id: '', opp: '', ha: '' };

      // this.addPlayerList.players[0].player_id = this.playerTeamList[0].player_id;
      // this.addPlayerList.players[0].opp = "";
      // this.addPlayerList.players[0].ha = '';
      // this.selectedFilters.players = {
      //   players: [
      //     { player_id: this.playerTeamList[0].player_id, opp: "", ha: "" }]
      // }

      let tempSelectedTeam = this.playerTeamList[0].opp.split(',');
      tempSelectedTeam = this.setTeamList(tempSelectedTeam);
      const defaultPlayerData = { player_id: '', opp: '', ha: '', teamList: tempSelectedTeam };
      this.selectedFilters.players = {
        players: [
          { player_id: this.playerTeamList[0].player_id, opp: '', ha: '' }]
      };

      this.addPlayerList.players.push(defaultPlayerData);
      // console.log(this.addPlayerList);
    } else {
      alert('You can only select 5 players at a time.');
    }
  }

  PlayersTeamListOfSideBaFilters(isFilterApplied) {
    const item = {
      platform_id: this.selectedFilters.platformId.toString(),
      sport_id: this.selectedFilters.sportId.toString(),
      slates_id: this.selectedFilters.slate.toString(),
      player_type: this.selectedFilters.player_type.toString() ? this.selectedFilters.player_type.toString() : '',
    };
    this.SpinnerService.show();
    this.api.playerTeamList(item).subscribe(data => {
      this.SpinnerService.hide();
      if (data && data.code == 100) {
        this.playerTeamList = data.data.playerTeamList;

        this.playerTeamList = this.playerTeamList.filter((el) => {
          return el.opp != null;
        });
        // If player id is not found then set first item
        if (this.playerId && this.playerTeamList.some(e => e.player_id == this.playerId)) {
          if (isFilterApplied) {
            this.playerId = data.data.selectedPlayer.player_id;
          }
        } else {
          this.playerId = data.data.selectedPlayer.player_id;
        }
        this.addPlayerList.players[0].player_id = this.playerId;
        this.addPlayerList.players[0].opp = '';
        // this.addPlayerList.players[0].opp = tempSelectedTeam[0];
        this.addPlayerList.players[0].ha = '';


        let tempSelectedTeam = data['data']['selectedPlayer']['opp'].split(',');
        tempSelectedTeam = this.setTeamList(tempSelectedTeam);
        this.addPlayerList.players[0].teamList = tempSelectedTeam;
        // this.selectedFilters.expensiveSelectedPlayer = data.data.selectedPlayer.player_id;
        this.selectedFilters.players = {
          players: [
            { player_id: this.playerId, opp: '', ha: '' }]
        };
        // console.log(data.message);
      } else {
        this.addPlayerList.players = [{
          player_id: '',
          opp: '',
          ha: '',
          teamList: []
        }];
        this.selectedFilters.players = {
          players: [
            { player_id: '', opp: '', ha: '' }]
        };
        // console.log(data.message);
      }

      this.trendPlayerList();
    }, (err) => {
      this.SpinnerService.hide();
      // console.log('Somthing went wrong');
    });
  }

  onClosePlayer(item, index) {
    // console.log('clicked' + item);
    this.addPlayerList.players.splice(index, 1);
    // console.log(this.addPlayerList);
  }

  onResetTrendsFilter() {

    this.selectedFilters.recordType = 'game';
    this.selectedFilters.limit = this.sharedService.defaultLimit;

    if (this.FiltersData && this.FiltersData.categoryList && this.FiltersData.categoryList.length > 0) {
      this.selectedFilters.categoryName = this.FiltersData.categoryList[0].value;
      this.categoryName = this.FiltersData.categoryList[0].name;
    } else {
      this.selectedFilters.categoryName = '';
      this.categoryName = '';
    }
    if (this.playerTeamList && this.playerTeamList.length > 0) {
      let tempSelectedTeam = this.playerTeamList[0].opp.split(',');
      tempSelectedTeam = this.setTeamList(tempSelectedTeam);
      this.addPlayerList.players = [{ player_id: this.playerId.toString(), opp: '', ha: '', teamList: tempSelectedTeam }];
      this.selectedFilters.players = {
        players: [
          { player_id: this.playerId.toString(), opp: '', ha: '' }]
      };
    } else {
      this.addPlayerList.players = [{ player_id: '', opp: '', ha: '', teamList: [] }];
      this.selectedFilters.players = {
        players: [
          { player_id: '', opp: '', ha: '' }]
      };
    }

    this.trendPlayerList();
  }

  setTeamList(tempSelectedTeam) {
    if (tempSelectedTeam) {
      return tempSelectedTeam = tempSelectedTeam.sort((m, n) => m - n);
    }
  }

  onSubmitTrendsFilter() {
    // this.selectedFilters.players = this.addPlayerList;
    const tempPlayerData = { players: [] };
    this.addPlayerList.players.forEach(element => {
      const tempObj: any = {};
      tempObj.ha = element.ha;
      tempObj.opp = element.opp;
      tempObj.player_id = element.player_id;
      tempPlayerData.players.push(tempObj);
    });
    this.selectedFilters.players = tempPlayerData;
    this.trendPlayerList();
  }

  changeCategory(ev?: any) {
    this.categoryName = this.FiltersData.categoryList.find(m => m.value === this.selectedFilters.categoryName).name;
  }


  changePlayerType(event) {
    this.selectedFilters.player_type = '';
    this.selectedFilters.player_type = event.target.value;
    let userDetail = JSON.parse(localStorage.getItem('userDetails'));
    if (userDetail) {
      userDetail['fieldType'] = event.target.value;
      localStorage.setItem('userDetails', JSON.stringify(userDetail));
    }

    this.PlayersTeamListOfSideBaFilters(true);
  }

  addRemovePlayer(item) {
    const player = {
      player_id: item.player_id,
      slates_id: this.selectedFilters.slate,
    };

    if (item && item.is_manager) {
      this.sharedService.addPlayerForManager(player).then(res => {
        item.is_manager = res;
      });
    } else {
      this.sharedService.onRemovePlayer(player).then(res => {
        item.is_manager = res;
      });
    }
  }

  setMLBColor(item) {
    item.data.listPlayer.forEach(element => {
      if (this.selectedFilters.player_type == 'batting') {
        element.category.avg.gm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.avg['gm' + this.selectedFilters.limit], key: 'element.category.avg.gm' + this.selectedFilters.limit, sport: 'MLB', player_type: this.selectedFilters.player_type }, this.getColorReverseCondition(false));
        element.category.obp.gm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.obp['gm' + this.selectedFilters.limit], key: 'element.category.obp.gm' + this.selectedFilters.limit, sport: 'MLB', player_type: this.selectedFilters.player_type }, this.getColorReverseCondition(false));
        element.category.slg.gm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.slg['gm' + this.selectedFilters.limit], key: 'element.category.slg.gm' + this.selectedFilters.limit, sport: 'MLB', player_type: this.selectedFilters.player_type }, this.getColorReverseCondition(false));
        element.category.ops.gm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.ops['gm' + this.selectedFilters.limit], key: 'element.category.ops.gm' + this.selectedFilters.limit, sport: 'MLB', player_type: this.selectedFilters.player_type }, this.getColorReverseCondition(false));
        element.category.iso.gm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.iso['gm' + this.selectedFilters.limit], key: 'element.category.iso.gm' + this.selectedFilters.limit, sport: 'MLB', player_type: this.selectedFilters.player_type }, this.getColorReverseCondition(false));
        element.category.babip.gm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.babip['gm' + this.selectedFilters.limit], key: 'element.category.babip.gm' + this.selectedFilters.limit, sport: 'MLB', player_type: this.selectedFilters.player_type }, this.getColorReverseCondition(false));
        element.category.ct.gm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.ct['gm' + this.selectedFilters.limit], key: 'element.category.ct.gm' + this.selectedFilters.limit, sport: 'MLB', player_type: this.selectedFilters.player_type }, this.getColorReverseCondition(false));
        element.category.rc.gm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.rc['gm' + this.selectedFilters.limit], key: 'element.category.rc.gm' + this.selectedFilters.limit, sport: 'MLB', type: 'rank', player_type: this.selectedFilters.player_type }, this.getColorReverseCondition(false, 'rank'));
        element.category.bbk.gm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.bbk['gm' + this.selectedFilters.limit], key: 'element.category.bbk.gm' + this.selectedFilters.limit, sport: 'MLB', player_type: this.selectedFilters.player_type }, this.getColorReverseCondition(false));
        element.category.walk.gm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.walk['gm' + this.selectedFilters.limit], key: 'element.category.walk.gm' + this.selectedFilters.limit, sport: 'MLB', player_type: this.selectedFilters.player_type }, this.getColorReverseCondition(false));
      }



      /*pitching category*/
      if (this.selectedFilters.player_type == 'pitching') {
        element.category.ip.gm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.ip['gm' + this.selectedFilters.limit], key: 'element.category.ip.gm' + this.selectedFilters.limit, sport: 'MLB', player_type: this.selectedFilters.player_type }, this.getColorReverseCondition(false));
        element.category.so.gm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.so['gm' + this.selectedFilters.limit], key: 'element.category.so.gm' + this.selectedFilters.limit, sport: 'MLB', player_type: this.selectedFilters.player_type }, this.getColorReverseCondition(false));
        element.category.era.gm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.era['gm' + this.selectedFilters.limit], key: 'element.category.era.gm' + this.selectedFilters.limit, sport: 'MLB', player_type: this.selectedFilters.player_type }, this.getColorReverseCondition(false));
        element.category.whip.gm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.whip['gm' + this.selectedFilters.limit], key: 'element.category.whip.gm' + this.selectedFilters.limit, sport: 'MLB', player_type: this.selectedFilters.player_type }, this.getColorReverseCondition(false));
        element.category.fip.gm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.fip['gm' + this.selectedFilters.limit], key: 'element.category.fip.gm' + this.selectedFilters.limit, sport: 'MLB', player_type: this.selectedFilters.player_type }, this.getColorReverseCondition(false));
        element.category.k9.gm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.k9['gm' + this.selectedFilters.limit], key: 'element.category.k9.gm' + this.selectedFilters.limit, sport: 'MLB', player_type: this.selectedFilters.player_type }, this.getColorReverseCondition(false));
        element.category.bb9.gm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.bb9['gm' + this.selectedFilters.limit], key: 'element.category.bb9.gm' + this.selectedFilters.limit, sport: 'MLB', player_type: this.selectedFilters.player_type }, this.getColorReverseCondition(false));
        element.category.kbb.gm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.kbb['gm' + this.selectedFilters.limit], key: 'element.category.kbb.gm' + this.selectedFilters.limit, sport: 'MLB', player_type: this.selectedFilters.player_type }, this.getColorReverseCondition(false));
        element.category.hr9.gm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.hr9['gm' + this.selectedFilters.limit], key: 'element.category.hr9.gm' + this.selectedFilters.limit, sport: 'MLB', player_type: this.selectedFilters.player_type }, this.getColorReverseCondition(false));
      }
    });
  }

  getColorReverseCondition(d, type = null) {
    if (this.selectedFilters.typedisplay != 1 && type == null && type != 'rank') {
      // return !d;
    }
    return d;
  }


  openPlayerModalDialog(item) {
    console.log(item);
    this.defualtPopupTab = 'Last';
    // console.log(item, 'player');
    this.PopupLast5Position = '';
    this.popupLast5SalaryRange = '0, 100000.00';
    this.popupLast5SomeRange = [0, 100000.00];
    this.popUpLast5playerList = [];
    this.playerStatus = item.status;
    this.selectedPlayerForPopup = item;
    this.selectedPlayerForPopup.ha = this.selectedPlayerForPopup.ha.trim();
    this.selectedPlayerForPopup.team_symbol = (this.selectedPlayerForPopup.ha == 'h' || this.selectedPlayerForPopup.ha == 'H') ? ' vs. ' : ' @ ';
    this.getPlayerGameLog();
    this.onLast5Popup();
  }


  getPlayerGameLog() {
    const tmpData = {
      user_id: (this.loginUserDetails && this.loginUserDetails.user_id) ? this.loginUserDetails.user_id : '',
      platform_id: this.selectedFilters.platformId,
      sport_id: this.selectedFilters.sportId,
      player_id: String(this.selectedPlayerForPopup.player_id),
      player_type: this.selectedFilters.player_type,
    };
    this.SpinnerService.show();
    this.playerGameLogList = [];
    this.api.getPlayerGameLog(tmpData).subscribe(item => {
      this.SpinnerService.hide();
      if (item && item.code == 100) {
        if (item.data && item.data.gameLog) {
          this.playerGameLogList = item.data.gameLog;
        }
      }
    });
  }

  onPopupTabs(type, index) {
    this.defualtPopupTab = type;
    if (index == 1) {
      this.getPlayerGameLog();
      this.onTrendsPopup();
    } else if (index == 2) {
      this.PopupLast5Position = '';
      this.popupLast5SalaryRange = '0, 100000.00';
      this.popupLast5SomeRange = [0, 100000.00];
      this.popUpLast5playerList = [];
      this.onLast5Popup();
    } else if (index == 3) {
      this.onTrendsPopup();
    }
  }

  onLast5Popup() {

    const lastPlayersFiltersData = {
      user_id: (this.loginUserDetails && this.loginUserDetails.user_id) ? this.loginUserDetails.user_id : '',
      sport_id: this.selectedFilters.sportId,
      platform_id: this.selectedFilters.platformId,
      slates_id: this.selectedFilters.slate.toString(),
      position: this.PopupLast5Position,
      salary_range: this.popupLast5SalaryRange,
      player_id: this.selectedPlayerForPopup.player_id,
      player_type: this.selectedFilters.player_type ? this.selectedFilters.player_type : '',
      category_name: this.selectedFilters.categoryName ? this.selectedFilters.categoryName : 'fantasy_points' // this is extra value for getting api response
    };
    this.SpinnerService.show();
    this.api.last5PlayerList(lastPlayersFiltersData).subscribe(item => {
      this.SpinnerService.hide();
      if (item && item.code == 100) {

        this.popUpLast5playerList = item.data.listPlayer;
      } else {
        this.popUpLast5playerList = [];
      }
    }, (err) => {
      this.SpinnerService.hide();
      this.popUpLast5playerList = [];
      // console.log('something went wrong');
    });
  }


  onTrendsPopup() {
    const players = {
      players: [
        { player_id: this.selectedPlayerForPopup.player_id, opp: '', ha: this.selectedPlayerForPopup.ha }]
    };
    const trendsPlayersFiltersData = {
      sport_id: this.selectedFilters.sportId,
      platform_id: this.selectedFilters.platformId,
      category_name: this.selectedFilters.categoryName,
      record_type: 'game',
      limit: this.selectedFilters.limit,
      players: JSON.stringify(players)
    };
    this.SpinnerService.show();
    this.api.trendsPlayerList(trendsPlayersFiltersData).subscribe(item => {
      this.SpinnerService.hide();
      if (item && item.code == 100) {
        this.popupTrendPlayerList = item.data;
      } else {
        this.popupTrendPlayerList = { data: [], labelList: [] };
      }
      this.graphView();
    }, (err) => {
      this.SpinnerService.hide();
      this.popupTrendPlayerList = { data: [], labelList: [] };
      this.graphView();
      // console.log('something went wrong');
    });


  }


  onSeeMoreLast5() {
    const currentUrl = this.route.url;
    this.navService.changeNavHeaderActive(currentUrl);
    this.route.navigate(['/Last5']);
  }

  gmColor(value, sportId = 1, categoryName = 'fantasy_points') {
    return this.sharedService.getLast5ColorCode(value, sportId, categoryName);
  }



  // Build fix
  categoryList: any;
  onSeeMoreTrend() {

  }
}

